import { Component, Input, Output, EventEmitter } from '@angular/core';

// INTERFACES
import { trackById } from '../../../shared/util';

import { IApprovalUserTemplate } from './../../interfaces/approval.interface';

@Component({
  selector: 'lum-approval-user-template-table',
  templateUrl: './approval-user-template-table.component.html',
  styleUrls: ['./approval-user-template-table.component.scss'],
})
export class ApprovalUserTemplateTableComponent {
  @Input()
  data :IApprovalUserTemplate[] = [];

  @Output()
  deleteEvent = new EventEmitter<number>();

  @Output()
  editEvent = new EventEmitter<number>();

  trackById = trackById;

  constructor() {}
}
